import { Stack } from '@mui/material'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface FeedConsumptionHeaderProps {
	distributedFood: number
	consumptionFood: number
}

const FeedConsumptionHeader = ({
	distributedFood,
	consumptionFood,
}: FeedConsumptionHeaderProps) => {
	return (
		<>
			<Stack direction='column' gap='8px'>
				<TypographySecondary>Итого за период</TypographySecondary>

				{distributedFood != null && (
					<Stack direction='row' alignItems='baseline' gap='4px'>
						<TypographyPrimary16Bold>{distributedFood}</TypographyPrimary16Bold>
						<TypographyPrimary>кг</TypographyPrimary>
					</Stack>
				)}

				<TypographySecondary>Расход корма</TypographySecondary>
			</Stack>

			<Stack direction='column' gap='8px'>
				<TypographySecondary>Итого за период</TypographySecondary>

				{consumptionFood != null && (
					<Stack direction='row' alignItems='baseline' gap='4px'>
						<TypographyPrimary16Bold>{consumptionFood}</TypographyPrimary16Bold>
						<TypographyPrimary>кг</TypographyPrimary>
						{distributedFood > 0 && (
							<>
								<TypographyPrimary>/</TypographyPrimary>
								<TypographyPrimary16Bold>
									{Math.round((consumptionFood / distributedFood) * 100)}%
								</TypographyPrimary16Bold>
							</>
						)}
					</Stack>
				)}

				<TypographySecondary>Остаток</TypographySecondary>
			</Stack>
		</>
	)
}

export default FeedConsumptionHeader
